// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1lxaocf0 {
  flex-basis: 100%;
}
._1lxaocf1 {
  flex-basis: 80px;
  flex-shrink: 0;
}
._1lxaocf2 {
  flex-basis: 40px;
  flex-shrink: 0;
}
._1lxaocf3 {
  font-size: 18px;
  font-weight: 400;
}
._1lxaocf4 {
  color: var(--_18w76bw2w);
  font-size: 18px;
  font-weight: 400;
}
._1lxaocf5 {
  color: var(--_18w76bw2w);
}
@media screen and (min-width: 768px) {
  ._1lxaocf0 {
    flex-basis: calc(100% - 120px);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":["._1lxaocf0 {\n  flex-basis: 100%;\n}\n._1lxaocf1 {\n  flex-basis: 80px;\n  flex-shrink: 0;\n}\n._1lxaocf2 {\n  flex-basis: 40px;\n  flex-shrink: 0;\n}\n._1lxaocf3 {\n  font-size: 18px;\n  font-weight: 400;\n}\n._1lxaocf4 {\n  color: var(--_18w76bw2w);\n  font-size: 18px;\n  font-weight: 400;\n}\n._1lxaocf5 {\n  color: var(--_18w76bw2w);\n}\n@media screen and (min-width: 768px) {\n  ._1lxaocf0 {\n    flex-basis: calc(100% - 120px);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
